// Static catalog mirroring the xdface library content.
// Update when books or editions are added to the library repo.

export interface LibraryBook {
  slug: string;
  title: string;
  author: string;
  year: number;
  url: string;
  coverUrl: string;
}

export interface LibraryEdition {
  year: number;
  slug: string;
  displayName: string;
  url: string;
  coverUrl: string;
}

const LIBRARY = 'https://library.xdface.net';

export const LIBRARY_BOOKS: LibraryBook[] = [
  {
    slug: 'vibe-coding-gene-kim-steve-yegge',
    title: 'Vibe Coding',
    author: 'Gene Kim & Steve Yegge',
    year: 2025,
    url: `${LIBRARY}/books/vibe-coding-gene-kim-steve-yegge/`,
    coverUrl: `${LIBRARY}/assets/books/vibe-coding-gene-kim-steve-yegge/cover.jpg`,
  },
  {
    slug: 'intelligent-agents-micheal-lanham',
    title: 'Intelligent Agents with LLMs',
    author: 'Micheal Lanham',
    year: 2025,
    url: `${LIBRARY}/books/intelligent-agents-micheal-lanham/`,
    coverUrl: `${LIBRARY}/assets/books/intelligent-agents-micheal-lanham/cover.jpg`,
  },
  {
    slug: 'ddia-2e-kleppmann-riccomini',
    title: 'Designing Data-Intensive Applications (2nd Ed.)',
    author: 'Martin Kleppmann & Chris Riccomini',
    year: 2026,
    url: `${LIBRARY}/books/ddia-2e-kleppmann-riccomini/`,
    coverUrl: `${LIBRARY}/assets/books/ddia-2e-kleppmann-riccomini/cover.jpg`,
  },
  {
    slug: 'ddia-1e-martin-kleppmann',
    title: 'Designing Data-Intensive Applications',
    author: 'Martin Kleppmann',
    year: 2017,
    url: `${LIBRARY}/books/ddia-1e-martin-kleppmann/`,
    coverUrl: `${LIBRARY}/assets/books/ddia-1e-martin-kleppmann/cover.jpg`,
  },
  {
    slug: 'inner-excellence-jim-murphy',
    title: 'Inner Excellence',
    author: 'Jim Murphy',
    year: 2020,
    url: `${LIBRARY}/books/inner-excellence-jim-murphy/`,
    coverUrl: `${LIBRARY}/assets/books/inner-excellence-jim-murphy/cover.jpg`,
  },
  {
    slug: 'speed-of-trust-stephen-covey',
    title: 'The Speed of Trust',
    author: 'Stephen M.R. Covey',
    year: 2006,
    url: `${LIBRARY}/books/speed-of-trust-stephen-covey/`,
    coverUrl: `${LIBRARY}/assets/books/speed-of-trust-stephen-covey/cover.jpg`,
  },
];

export const LIBRARY_EDITIONS: LibraryEdition[] = [
  {
    year: 2026,
    slug: 'hbr-march-april-2026',
    displayName: 'HBR Marzo–Abril 2026',
    url: `${LIBRARY}/2026/hbr-march-april-2026/`,
    coverUrl: `${LIBRARY}/assets/2026/hbr-march-april-2026/cover.jpg`,
  },
  {
    year: 2026,
    slug: 'hbr-10-must-reads',
    displayName: 'HBR 10 Must Reads',
    url: `${LIBRARY}/2026/hbr-10-must-reads/`,
    coverUrl: `${LIBRARY}/assets/2026/hbr-10-must-reads/cover.jpg`,
  },
  {
    year: 2025,
    slug: 'hbr-november-december-2025',
    displayName: 'HBR Noviembre–Diciembre 2025',
    url: `${LIBRARY}/2025/hbr-november-december-2025/`,
    coverUrl: `${LIBRARY}/assets/2025/hbr-november-december-2025/cover.jpg`,
  },
];
